import { create } from 'zustand';
import axios from 'axios';
import useUserStore from './user';

const bingoAssetsStore = create((set, get) => ({
  assets: {},
  pending: {},
  errors: {},

  isAssetLoading: (assetKey) => !!get().pending[assetKey],

  updateAsset: (key, data) =>
    set((state) => ({
      assets: { ...state.assets, [key]: data },
      pending: { ...state.pending, [key]: false },
    })),

  fetchAsset: async (key, url) => {
    if (!key || !url) return null;

    if (get().assets[key] || get().pending[key]) return get().assets[key];

    const baseURL = useUserStore.getState().user.apiURL;
    const fullUrl = `${baseURL}/${url}`;

    try {
      set((state) => ({
        pending: { ...state.pending, [key]: true },
      }));

      const response = await axios.get(fullUrl);
      get().updateAsset(key, response.data);

      return response.data;
    } catch (error) {
      set((state) => ({
        pending: { ...state.pending, [key]: false },
        errors: { ...state.errors, [key]: error },
      }));
      return null;
    }
  },

  fetchGameAssets: async (game) => {
    if (!game) return;

    const promises = [
      get().fetchAsset(game.backgroundBig, game.backgroundBig),
      get().fetchAsset(game.backgroundSmall, game.backgroundSmall),
      get().fetchAsset(game.logoBig, game.logoBig),
      get().fetchAsset(game.logoSmall, game.logoSmall),
    ];

    await Promise.all(promises);
    return get().getGameAssets(game);
  },

  fetchRoomAssets: async (room) => {
    if (!room?.nextRound?.bingoGame) return;
    const game = room.nextRound.bingoGame;

    const promises = [
      get().fetchAsset(game.backgroundSmall, game.backgroundSmall),
      get().fetchAsset(game.logoSmall, game.logoSmall),
    ];

    if (room.chatHost?.image) {
      promises.push(get().fetchAsset(room.chatHost.name, room.chatHost.image));
    }

    await Promise.all(promises);
    return get().getRoomAssets(room);
  },

  getGameAssets: (game) => {
    if (!game) return {};

    return {
      backgroundBig: get().assets[game.backgroundBig] || null,
      backgroundSmall: get().assets[game.backgroundSmall] || null,
      logoBig: get().assets[game.logoBig] || null,
      logoSmall: get().assets[game.logoSmall] || null,
    };
  },

  getRoomAssets: (room) => {
    if (!room?.nextRound?.bingoGame) return {};

    const game = room.nextRound.bingoGame;
    return {
      background: get().assets[game.backgroundSmall] || null,
      logo: get().assets[game.logoSmall] || null,
      chathostImg: room.chatHost?.image
        ? get().assets[room.chatHost.name] || null
        : null,
    };
  },
}));

export default bingoAssetsStore;
